import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { HistoryService } from '@/services/history/service/history.service';
import { ref } from 'vue';
import { createSharedComposable } from '@vueuse/core';
import type { HistoryState } from '@/services/history/type/history.type';
import { useDisposes } from '@/composables/use-disposes';
import { useNavBarState } from '@eureka/nav-bar/src/composables/use-navbar-store';

export const useHistory = createSharedComposable(() => {
    const historyService = injectService<HistoryService>(HistoryService);
    const historyData = ref<HistoryState>(historyService.getModelData());

    const updateState = (states: HistoryState) => {
        historyData.value = states;
    };

    const { queryList } = useNavBarState();
    const { disposes } = useDisposes();

    disposes.push(
        historyService.onStatesChange(updateState),
        historyService.onTaskTitleChange((title: string) => {
            queryList();
        })
    );

    return {
        historyService,
        historyData,
    };
});
